import { connect } from 'react-redux'
import moment from 'moment'

import EventTitle from '../components/EventTitle'
import { makeGetCurrentEvent } from '../selectors/events'

const mapStateToProps = (state) => {
  const getEvent = makeGetCurrentEvent()
  const event = getEvent(state)

  const eventDate = moment(event.startTime).format('MMM Do, h:mm A')
  const eventTitle = `${event.name} - ${eventDate}`

  return { eventTitle }
}

export default connect(mapStateToProps, null)(EventTitle)
